module.exports = __webpack_public_path__ + "img/biodc.a66534d6.png";